const Contacts = () => (
  <section className="card contacts">
    <h3 className="section-title" data-i18n="contacts_header">Kontaktai kebabinėms</h3>
    <div className="contact-card">
      <div className="contact-item">
        <strong>Karaliaus Mindaugo</strong>
        <a href="tel:+37068237079">+370 682 37079</a>
      </div>
      <div className="contact-item">
        <strong>Varnių (tik grynais)</strong>
        <a href="tel:+37061671041">+370 616 71041</a>
      </div>
    </div>
  </section>
);

export default Contacts;
